module.exports = __webpack_public_path__ + "static/planet-5518b8bdea13b4ffd90991aab79fc914.svg";